import React, { useState } from 'react';
import ContainerView from '../../ContainerView';
import BottomActions from '../../bottomActions';
import TrackWorkflow from '../../TrackWorkflow';
import Declaration from '../../customComponent/declaration';
export default function VendorDetailedView({
  vendorDetails,
  viewType,
  workflowDetails = {},
  workflowVendorContainerAction,
  workflowVendorContainerCommentAction,
  callVendorUpdate,
  getWorkflowComments,
  comment,
  userInfo,
  submitVendor,
  from,
  showCancelConfirmation,
}) {
  const [state, setState] = useState({});
  const { vendor_id, status, identification_id, is_gstin_flow } =
    vendorDetails || {};
  const {
    twf_states = [],
    twf_id,
    stateSetting: { item_action_status_map } = {},
    resource_id,
    is_completed,
  } = workflowDetails;
  const istrackWorkflowVisible = twf_states.length > 0;

  const checkValidation = () => {
    if (!state.declaration) {
      setState({ ...state, declarationErr: true });
      const element = document.querySelector('#vendor-declaration');
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return false;
    }
    setState({ ...state, declarationErr: false });
    return true;
  };
  const callWorkflowContainerAction = (typeOfAction, comment) => {
    const containerParam = {
      resource_id,
      action_map: JSON.stringify([
        {
          item_id: vendor_id,
          action: typeOfAction,
        },
      ]),
      twfs_id: twf_states?.[0]?.twfs_id,
      is_new_ui: true,
    };
    // workflowVendorContainerAction(param);
    const commentParam = {
      com_type: 4,
      sub_type: 242,
      twf_id,
      comment,
    };
    workflowVendorContainerCommentAction(
      containerParam,
      comment ? commentParam : null,
    );
  };
  const actionMapData = () => {
    let obj = {};
    is_completed
      ? { Deactivate: 'Deactivate' }
      : item_action_status_map || { Submit: 'Submit' };
    if (is_completed && status === 0) {
      obj = { Deactivate: 'Deactivate' };
    } else if (is_completed && status === 2) {
      obj = { Activate: 'Activate' };
    } else if (
      item_action_status_map &&
      Object.keys(item_action_status_map)?.length > 0
    ) {
      obj = item_action_status_map;
    } else {
      obj = { Submit: 'Submit' };
    }
    return obj;
  };

  const isRequesterApproverDiff =
    userInfo?.happay_id !== workflowDetails?.requestor?.happay_id;

  const panNumber =
    is_gstin_flow && identification_id?.length === 15
      ? identification_id?.substring(2, 12)
      : identification_id;

  return (
    <div className="margin-t-118 detail-container">
      {istrackWorkflowVisible && (
        <TrackWorkflow
          data={workflowDetails}
          from="vendor"
          getWorkflowComments={getWorkflowComments}
          comment={comment}
        />
      )}
      {/* <ContainerView
        cardTitle="GSTIN Details"
        cardIndex={1}
        type="secondary"
        mappedValues={[
          {
            text: 'Is your vendor GSTIN registered?',
            key: 'is_gstin_flow',
            staticText: vendorDetails?.is_gstin_flow ? 'Yes' : 'No',
          },
          { text: 'GSTIN', key: 'identification_id' },
        ]}
        data={{ ...vendorDetails }}
        className="margin-b-20"
      /> */}
      <ContainerView
        cardTitle="Vendor Details"
        cardIndex={1}
        type="secondary"
        mappedValues={[
          { text: 'Display Name', key: 'display_name' },
          { text: 'Vendor Registered Name', key: 'vendor_name' },
          {
            text: 'GSTIN',
            key: vendorDetails?.is_gstin_flow ? 'identification_id' : '',
          },
          { text: 'PAN Number', key: 'pan_number' },
          { text: 'Address', key: 'address' },
          { text: 'City', key: 'city' },
          { text: 'State', key: 'state' },
          { text: 'Pincode', key: 'pincode' },
        ]}
        data={{
          ...vendorDetails,
          ...vendorDetails?.identification_details,
          pan_number: panNumber,
        }}
        className="margin-b-20"
        border="right"
      />
      <ContainerView
        cardTitle="Contact Details"
        cardIndex={2}
        type="secondary"
        mappedValues={[
          { text: 'Name', key: 'contact_name' },
          { text: 'Email ID', key: 'email_id' },
          {
            text: 'Contact Number',
            key: 'mobile_number',
            type: 'mobile_number',
            extension_key: 'mobile_extension',
          },
        ]}
        data={{ ...vendorDetails }}
        className="margin-b-20"
      />
      <ContainerView
        cardTitle="Bank Account Details"
        cardIndex={3}
        type="secondary"
        mappedValues={[
          { text: 'Beneficiary Name', key: 'beneficiary_name' },
          { text: 'Bank Account Number', key: 'account_number' },
          { text: 'IFSC', key: 'ifsc_code' },
          {
            text: 'Cancelled Cheque',
            key: 'cancelled_cheque_copy',
            type: 'file',
            hideBorder: true,
          },
        ]}
        data={{ ...vendorDetails, ...vendorDetails?.bank_details }}
        className="margin-b-20"
      />
      <Declaration
        onClick={(e, val) =>
          setState({ ...state, declaration: val, declarationErr: !val })
        }
        id="vendor-declaration"
        value={from === 'workflow' ? true : state.declaration}
        error={state.declarationErr}
        checkBoxWrapperStyle={
          state.declarationErr ? { paddingBottom: '60px' } : {}
        }
        disabled={from === 'workflow'}
      />
      <BottomActions
        submitDisabled={
          !vendorDetails?.bank_details?.cancelled_cheque_copy?.length
        }
        hideSave
        viewType={viewType}
        handleActionClick={(typeOfAction, comment) =>
          from === 'nonworkflow'
            ? submitVendor()
            : ['Deactivate', 'Activate'].includes(typeOfAction)
            ? callVendorUpdate(typeOfAction)
            : callWorkflowContainerAction(typeOfAction, comment)
        }
        actionMap={actionMapData()}
        from="Vendor"
        validation={from === 'workflow' ? false : checkValidation}
        // showCommentField={
        //   item_action_status_map &&
        //   Object.keys(item_action_status_map)?.length > 0
        // }
        isRequesterApproverDiff={isRequesterApproverDiff}
        showCancelConfirmation={showCancelConfirmation}
      />
    </div>
  );
}
